import { createSlice } from '@reduxjs/toolkit';

const pdfDetailsSlice = createSlice({
  name: "pdfDetails",
  initialState: { pdfPages: [], selectedDocument: null },
  reducers: {
    pdfDetails(state, action) {
      const { payload } = action;
      return { ...state, pdfPages: payload };
    },
    currDocument(state, action) {
      const { payload } = action;
      return { ...state, selectedDocument: payload };
    },
    updateSelectedDocument(state, action) {
      const { payload } = action;
      return { ...state, selectedDocument: payload };
    },
  },
});

export const { pdfDetails, currDocument, updateSelectedDocument } =
  pdfDetailsSlice.actions;
export default pdfDetailsSlice.reducer;
